import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { OpenStatistics } from "interface/sales";
import { GrideDateFormatter } from "ui/Date";

interface OpenedStatisticsMobileListProps {
	items: OpenStatistics[];
	loading: boolean;
}

const formatWeight = (value?: number | null) => {
	const asNumber = Number(value || 0);
	return `${asNumber.toLocaleString("no-NO", {
		maximumFractionDigits: 2,
	})} kg`;
};

const formatAmount = (value?: number | null) => {
	const asNumber = Number(value || 0);
	return asNumber.toLocaleString("no-NO", {
		maximumFractionDigits: 2,
		style: "currency",
		currency: "NOK",
	});
};

const OpenedStatisticsMobileList: FC<OpenedStatisticsMobileListProps> = ({
	items,
	loading,
}) => {
	const { t } = useTranslation();
	const empty = !loading && items.length === 0;

	return (
		<div className="opened-statistics-list-mobile">
			{empty && (
				<div className="opened-statistics-list-mobile-empty">{t("NoRows")}</div>
			)}

			{items.map((item, itemIndex) => {
				const itemKey = `${item.contractNoteNumber || "nocontract"}-${item.landingNoteNumber || "nolanding"}-${item.lineNumber || itemIndex}-${itemIndex}`;

				return (
					<div key={itemKey} className="opened-statistics-list-card">
						<div className="opened-statistics-list-card-header">
							<div className="opened-statistics-list-card-note">
								{item.productDescription || "-"}
							</div>
						</div>

						<div className="opened-statistics-list-card-body">
							<div>
								<span>{t("Species")}</span>
								<strong>{item.specieDescription || "-"}</strong>
							</div>
							<div>
								<span>{t("FishingGear")}</span>
								<strong>{item.fishingGearDescription || "-"}</strong>
							</div>
							<div className="opened-statistics-list-card-body-full">
								<span>{t("CatchArea")}</span>
								<strong>
									{item.catchAreaDescription || item.catchAreaCode || "-"}
									{item.catchAreaZone ? ` / ${item.catchAreaZone}` : ""}
								</strong>
							</div>
							<div>
								<span>{t("PreservationType")}</span>
								<strong>{item.productPreservationType || "-"}</strong>
							</div>
							<div>
								<span>{t("SalesDate")}</span>
								<strong>
									<GrideDateFormatter
										date={item.salesDateTime}
										formatType="dd.MM.yyyy"
										noTd={true}
									/>
								</strong>
							</div>
						</div>

						<div className="opened-statistics-list-card-footer">
							<div>
								<span>{t("GrossWeight")}</span>
								<strong>{formatWeight(item.grossWeight)}</strong>
							</div>
							<div>
								<span>{t("Price")}</span>
								<strong>{formatAmount(item.buyerPrice)}</strong>
							</div>
							<div>
								<span>{t("Value")}</span>
								<strong>{formatAmount(item.buyerValue)}</strong>
							</div>
						</div>
					</div>
				);
			})}

			{loading && (
				<div className="opened-statistics-list-mobile-loading">{t("Loading")}</div>
			)}
		</div>
	);
};

export default OpenedStatisticsMobileList;